<template>
  <div class="flex flex-col h-full">
    <div class="w-full h-full flex-1 flex flex-col items-center text-white">
      <template v-if="sharedData.showAmount === 2">
        <Image class="size-[58px] mt-[80px]" :src="success" alt="" />
        <span class="text-[var(--theme-gray100)] text-[25px] font-bold mt-[20px]">
          R$ {{ formatter().format(sharedData?.amount) }}
        </span>
        <span class="text-[12px] mt-6 leading-[14px] text-[#95979b]">
          {{ $t("Saque.SaqueSuccess.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ sharedData.orderNo }}
        </span>
        <div class="text-[20px] mt-[15px] mb-[10px]">
          {{ $t("Saque.SaqueSuccess.WithdrawalRequestSent") }}
        </div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t("Saque.SaqueSuccess.WithdrawalSuccessMessage") }}
        </div>
        <van-button @click="navigateHome" class="mt-[30px] primaryBtn !w-[356px]">
          {{ $t("Saque.SaqueSuccess.BackToHome") }}
        </van-button>
      </template>
      <template v-if="sharedData.showAmount === 3">
        <Image class="size-[58px] mt-[80px]" :src="fail" alt="" />
        <span class="text-[#64F765] text-[25px] font-bold mt-[20px]">
          R$ {{ formatter().format(sharedData?.amount) }}
        </span>
        <span class="text-[12px] mt-6 leading-[14px] text-[#95979b]">
          {{ $t("Saque.SaqueSuccess.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ sharedData?.orderNo }}
        </span>
        <div class="text-[20px] mt-[25px] mb-[10px]">
          {{ $t("Saque.SaqueSuccess.WithdrawalRequestFailed") }}
        </div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t("Saque.SaqueSuccess.WithdrawalFailedMessage") }}
        </div>
        <div
          @click="navigateCustomerService"
          class="text-[14px] flex items-center gap-2 mt-6 text-center px-[50px] leading-[16px] text-white/70"
        >
          <Image class="size-[24px] mr-2" :src="customerService" alt="" />
          <span class="text-[#64F765]">{{
            $t("Saque.SaqueSuccess.CustomerService")
          }}</span>
        </div>
        <van-button @click="navigateHome" class="mt-[30px] primaryBtn !w-[356px]">
          {{ $t("Saque.SaqueSuccess.BackToHome") }}
        </van-button>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { formatter } from "@/utils";
import success from "../images/success.png";
import fail from "../images/fail.png";
import customerService from "../images/customerService.png";
import { useGameFlowStore } from "@/store";
const flowStore = useGameFlowStore();
const router = useRouter();

const sharedData: any = inject("sharedData");
const navigateHome = () => {
  if (router.currentRoute.value.path.includes("game")) {
    flowStore.hide();
  } else {
    router.push("/");
  }
};
const navigateCustomerService = () => {
  router.push("/servico");
};
</script>
<style lang="scss" scoped></style>
